import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import type { ProductFamily } from '../types';
import { getProductFamilyById } from '../../../api/resilience/resilience.api';
import { DEFAULT_STALE_TIME_MS, DEFAULT_CACHE_TIME_MS } from '../constant';
import { useIsoLanguageCode } from '../../../utils/hooks/useIsoLanguageCode';

export function useProductFamilyById(productFamilyId: string) {
  const isoLanguageCode = useIsoLanguageCode();

  return useQuery<ProductFamily, AxiosError>({
    queryKey: [
      `/v1/configurator/product-families/{productFamilyId}`,
      { isoLanguageCode, productFamilyId },
    ],
    queryFn: async () => {
      const res = await getProductFamilyById(productFamilyId, {
        params: {
          isoLanguageCode,
        },
      });
      return res.data;
    },
    enabled: !!productFamilyId,
    staleTime: DEFAULT_STALE_TIME_MS,
    cacheTime: DEFAULT_CACHE_TIME_MS,
  });
}
